export default "__VITE_ASSET__BNCJeolv__"